const { omit } = require('lodash');
const mergeStyleToAttributes = require('../mergeStyleToAttributes');
const { BLACKLISTED_PROPS } = require('./constants');

/**
 * Return Layer's "cleaned" props by omitting blacklisted.
 * @param props - Props to clean
 * @returns {Object}
 */
const getLayerProps = (props) => omit({
    ...props,
    ...mergeStyleToAttributes(props)
}, BLACKLISTED_PROPS);

module.exports = getLayerProps;
